import { Dispatch, SetStateAction } from "react";
import * as s from "../InputPage.styles";
import { styled } from "styled-components";
import TaskSection from "./TaskSection";
import { AnalysisForm } from "../machine";
import WeightSection from "./WeightSection";

interface Props {
  formData: AnalysisForm;
  setFormData: Dispatch<SetStateAction<AnalysisForm>>;
  handleSubmit: () => void;
}

function TaskInfo({ formData, setFormData, handleSubmit }: Props) {
  return (
    <s.Container>
      <s.Header>
        <s.StepWrapper>
          <s.Step>Step 1</s.Step>
          <s.StepDivider />
          <s.Step>Step 2</s.Step>
          <s.StepDivider />
          <s.Step $active>Step 3</s.Step>
        </s.StepWrapper>
        <s.Title>작업 및 가중치 조정</s.Title>
        <s.Address>
          보유한 부속기의 작업 조건을 입력해 실제 현장 효율과 필요 대수를
          계산해보세요. 마력, 토양, 작업환경 등에 따라 효율을 조정할 수도
          있습니다.
        </s.Address>
      </s.Header>
      <s.Content>
        <TaskSection formData={formData} setFormData={setFormData} />
        <WeightSection formData={formData} setFormData={setFormData} />

        <CompleteButton onClick={handleSubmit}>
          트랙터/부속기 효율분석
        </CompleteButton>
      </s.Content>
    </s.Container>
  );
}

export default TaskInfo;

const CompleteButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Alias-Color-Button-cta-light-background-Primary, #1e9b6b);
  color: var(--Alias-Color-Text-White-Text-Primary, #fff);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/S-14-Bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;
